
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherObservation } from './GenWeatherObservation';
import moment from 'moment';

export class GenWeatherEvent {

    associationBasis: string;
    associationGapHours: number;
    burden: number;
    category: string;
    curveReview: boolean;
    curveReviewFlags: string;
    end: moment.Moment;
    escalationMinutes: number;
    escalationOverlapHours: number;
    eventId: string;
    high: moment.Moment;
    observations: GenWeatherObservation[];
    peakCustomers: number;
    peakFraction: number;
    peakTime: moment.Moment;
    profile: string;
    recoveryMinutes: number;
    review: boolean;
    reviewFlags: string;
    start: moment.Moment;
    totalCustomers: number;
    weatherEpisodeId: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherEvent: GenWeatherEvent);

    constructor( input?: GenWeatherEvent ) {
        if ( input && typeof input !== 'number' ) {
            this.associationBasis = input.associationBasis; // string [string]
            this.associationGapHours = input.associationGapHours; // float [number]
            this.burden = input.burden; // float [number]
            this.category = input.category; // string [string]
            this.curveReview = input.curveReview; // boolean [boolean]
            this.curveReviewFlags = input.curveReviewFlags; // string [string]
            if ( input.end && typeof input.end === 'string' ) {
                this.end = moment(input.end).utc();
            } else {
                this.end = input.end;
            }
            this.escalationMinutes = input.escalationMinutes; // float [number]
            this.escalationOverlapHours = input.escalationOverlapHours; // float [number]
            this.eventId = input.eventId; // string [string]
            if ( input.high && typeof input.high === 'string' ) {
                this.high = moment(input.high).utc();
            } else {
                this.high = input.high;
            }
            if ( input.observations && input.observations.map ) { // list [GenWeatherObservation]
                this.observations = input.observations.map( ( x: GenWeatherObservation ) => {
                    return new GenWeatherObservation( x );
                } );
            } else {
                this.observations = input.observations;
            }
            this.peakCustomers = input.peakCustomers; // float [number]
            this.peakFraction = input.peakFraction; // float [number]
            if ( input.peakTime && typeof input.peakTime === 'string' ) {
                this.peakTime = moment(input.peakTime).utc();
            } else {
                this.peakTime = input.peakTime;
            }
            this.profile = input.profile; // string [string]
            this.recoveryMinutes = input.recoveryMinutes; // float [number]
            this.review = input.review; // boolean [boolean]
            this.reviewFlags = input.reviewFlags; // string [string]
            if ( input.start && typeof input.start === 'string' ) {
                this.start = moment(input.start).utc();
            } else {
                this.start = input.start;
            }
            this.totalCustomers = input.totalCustomers; // float [number]
            this.weatherEpisodeId = input.weatherEpisodeId; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherEvent[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherEvent(a));
        } else {
          return [];
        }
    }
}

